const carRental = {
  carRental: "렌터카", // translated 
  carRentals: "렌터카", // translated 
  pickUpPoint: "픽업 장소", // translated 
  dropOffPoint: "하차 지점", // translated 
  pleaseSelectAPickUpPoint: "픽업 장소를 선택해 주세요.", // translated 
  pickUpDate: "픽업 날짜", // translated 
  dropOffDate: "반납 날짜", // translated 
  pickUp: "찾다", // translated 
  dropOff: "하차", // translated 
  edit: "편집하다", // translated 
  fuelPolicy: "연료 정책", // translated 
  pickUpLocation: "픽업 장소", // translated 
  mileage: "사용량", // translated 
  transmission: "전염", // translated 
  airCondition: "에어컨", // translated 
  minimumAge: "최소 연령", // translated 
  maximumAge: "최대 연령", // translated 
  providerAddress: "제공자 주소", // translated 
  providerPhone: "제공자 전화번호", // translated 
  driverInfo: "운전자 정보", // translated 
  driversInfo: "운전자 정보", // translated 
  differentDropOff: "다른 장소에 하차", // translated 
  maxPassengers: "최대 승객 수", // translated 
  budget: "예산", // translated 
  provider: "공급자", // translated 
  carModel: "자동차 모델", // translated 
  numOfDoors: "문의 개수", // translated 
  fuelType: "연료 종류", // translated 
  driverAge: "운전자의 나이", // translated 
  enterValidDriversAge: "운전자의 나이를 정확하게 입력해 주세요.", // translated 
  workingHours: "근무 시간", // translated 
  driverNationality: "운전자의 국적", // translated 
  nationalityIsRequired: "국적이 필요합니다", // translated 
  carRentalRate: "렌터카 요금", // translated 
  dueNow: "지금 바로 납부하세요", // translated 
  duePickUp: "수령 시 지불", // translated 
  toViewOfferPDF:
    "본 제안의 모든 임대 조건을 담은 PDF 문서를 보시려면,", // translated 
  toViewTermsAndCondPDF:
    "적용되는 CARNECT 이용 약관을 보려면 다음을 참조하십시오.", // translated 
  carRentalsNotFound:
    "차량 렌탈 검색 결과를 찾을 수 없었습니다. 불편을 드려 죄송합니다.", // translated 
};


export default carRental;
